'use strict';

const {noMoreThan, fillWithShapeOptions} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('sub-polygons', function () {

    const select = this.query('select');
    fillWithShapeOptions(select, 3, 20, 6);

    const [label, ratioInput] = this.addLabeledSlider('Sub-polygon Ratio: ', 1, 100, 50);

    const _updateDrawing = () => {
        const shape = new Shape(parseInt(select.value, 10), Point.origin(), 100);
        shape.scaleToFitWithin(this.width - this.pad * 2, this.width - this.pad * 2);
        shape.setAnchorPoint(new Point(this.pad, this.pad));

        let ratio = parseInt(ratioInput.value, 10) / 100;
        label.innerText = ratio.toFixed(2);
        shape.setFractalProportion(ratio);
        let subShapes = shape.getProportionalSubShapes();

        this.wipe();
        shape.draw(this.ctx);
        subShapes.forEach((shape) => {
            shape.draw(this.ctx);
        });
    };
    const updateDrawing = noMoreThan(_updateDrawing, 100);

    ratioInput.addEventListener('input', updateDrawing);
    select.addEventListener('change', updateDrawing);

    _updateDrawing();
});


